import { Component, OnInit, Input } from '@angular/core';
import { Organization } from 'src/app/@core/models/infrastructure/Organization.model';
import { InfrastructureService } from 'src/app/@core/services/infrastructure/infrastructure.service';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DarkModeService } from 'src/app/@core/services/dark-mode/dark-mode.service';

@Component({
  selector: 'app-org-acr-step',
  templateUrl: './org-acr-step.component.html',
  styleUrls: ['./org-acr-step.component.scss'],
})
export class OrgAcrStepComponent implements OnInit {

  constructor(private infraService: InfrastructureService,
    private translate: TranslateService,
    private snackBar: MatSnackBar,
    public darkModeService: DarkModeService) { }

  @Input() organization: Organization;
  tokenExist: boolean = false;
  showToken: boolean = false;
  acrTokenUsername: String;
  acrTokenPassword: String;

  ngOnInit(): void {
    this.checkOrganizationTokenExist()
  }

  checkOrganizationTokenExist() {
    this.infraService.getAcrOrganizationTokens(this.organization.shortName).subscribe(secrets => {
      if(secrets.length) {
        this.tokenExist = true;
        this.acrTokenPassword = atob(secrets[0].secretValue)
        this.acrTokenUsername = atob(secrets[1].secretValue)
      }
    })
  }

  generateOrganizationToken() {
    this.infraService.getAcrOrganizationTokens(this.organization.shortName).subscribe(secrets => {
      if(secrets.length) {
        this.tokenExist = true;
        this.acrTokenPassword = atob(secrets[0].secretValue)
        this.acrTokenUsername = atob(secrets[1].secretValue)
      } else {
        this.infraService.checkAcrTokenCreation(this.organization.shortName).subscribe(result => {
          if(result.jenkinsStatus === "unavailable") {
            const msg = this.translate.instant('ORG.ACR.WARNING-MESSAGE-TOKEN-UNAVAILABLE');
            this.snackBar.open(msg, null, { duration: 5000, panelClass: ['custom-snackbar-text'] });
          } else {
            if(result.jobStatus === "available") {
              this.infraService.generateAcrToken(this.organization.shortName).subscribe()
              const msg = this.translate.instant('ORG.ACR.CONFIRM-MESSAGE-TOKEN-GENERATING');
              this.snackBar.open(msg, null, { duration: 5000, panelClass: ['custom-snackbar-text-success'] });
            } else {
              const msg = this.translate.instant('ORG.ACR.WARNING-MESSAGE-TOKEN-GENERATING');
              this.snackBar.open(msg, null, { duration: 5000, panelClass: ['custom-snackbar-text'] });
            }
          }
        })
      }
    })
  }

  toogleShowCredentials() {
    this.showToken = true;
    setTimeout(() => {
      this.showToken = false;
    }, 10000);
  }
}
